import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Injectable, Optional, SkipSelf } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import versionHistoryJson from 'src/assets/version_history.json';
import { VersionInfo } from './models/versionInfo.data';

@Injectable({
  providedIn: 'root'
})
export class VersionHistoryService {
  private versions = new BehaviorSubject<VersionInfo[]>([]);
  private lastVersion = new BehaviorSubject<VersionInfo | null>(null);
  private lastUpdate: number;
  private versionDataJson: VersionInfo[] = [];

  constructor(private http: HttpClient, @Optional() @SkipSelf() thisService?: VersionHistoryService) {
    if (thisService) {
      throw new Error('Multiple instances of VersionHistoryDataService');
    }

    this.versionDataJson = versionHistoryJson.history.map(VersionInfo.mapTo).sort(VersionInfo.compare);
    this.lastUpdate = this.versionDataJson[0].date.valueOf();
  }

  public getLastUpdateDate(): number {
    return this.lastUpdate;
  }

  public getLastUpdateRaw(): VersionInfo {
    return this.versionDataJson[0];
  }

  public getVersionInfos$(): Observable<VersionInfo[]> {
    if (this.versions.getValue().length == 0) {
      this.initializeVersions();
    }
    return this.versions.asObservable();
  }

  public getLastVersionInfo$(): Observable<VersionInfo | null> {
    if (this.lastVersion.getValue() == null) {
      this.initializeVersions(true);
    }
    return this.lastVersion.asObservable();
  }

  private initializeVersions(last: boolean = false): void {
    const versionsToGet = last ? [this.versionDataJson[0]] : this.versionDataJson;
    versionsToGet.forEach((ver) => {
      this.http
        .get(`assets/versionInfos/${ver.number}.html`, { responseType: 'text' })
        .pipe(take(1))
        .subscribe((desc) => (ver.description = desc));
    });
    if (last) {
      this.lastVersion.next(versionsToGet[0]);
    } else {
      this.versions.next(versionsToGet);
    }
  }
}
